import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { timeInPast } from 'webui/utils/time';
import { hoverPointsOnMap, selectPointOnMap, } from 'entities/device.map.track/model/actions';
import { useAction } from 'shared/hooks/redux/hooks';
import { GetStillPhoto } from 'entities/device.photos/ui/single';
export const TooltipForPath = memo(function TooltipForPath(props) {
    const { device_id, hover_points, available_photos, photos_from_server } = props;
    const onHoverPointsOnMap = useAction(hoverPointsOnMap);
    const onSelectPointOnMap = useAction(selectPointOnMap);
    const onClick = useCallback((point) => {
        if (device_id != null) {
            onSelectPointOnMap(device_id, point);
            onHoverPointsOnMap(device_id, []);
        }
    }, [device_id, onSelectPointOnMap, onHoverPointsOnMap]);
    if (hover_points && hover_points.length > 0) {
        return (_jsx(_Fragment, { children: hover_points
                .slice()
                .reverse()
                .map((point, i) => (_jsxs("div", { children: [available_photos && photos_from_server.length > 0 && (_jsx(GetStillPhoto, { device_id: device_id, time: point.time, photos_from_server: photos_from_server })), _jsx("div", { className: "ui-track-tooltip-item", onClick: () => {
                            onClick(point);
                        }, children: `${timeInPast(point.time)} — ${point.speed} км/ч` })] }, i))) }));
    }
    return null;
});
